import { motion } from "framer-motion";
import { Heart, Activity, CheckCircle } from "lucide-react";

const specialties = [
  {
    icon: <Heart className="w-6 h-6 text-blue-600" />,
    title: "Cardiac Surgery Recovery",
    description: "Supporting critical post-operative care with intelligent monitoring",
    benefits: [
      "Continuous vitals tracking",
      "Medication adherence monitoring",
      "Cognitive function assessment",
      "Early complication detection"
    ]
  },
  {
    icon: <Activity className="w-6 h-6 text-blue-600" />,
    title: "Orthopedic Recovery",
    description: "Guiding patients through rehabilitation milestones",
    benefits: [
      "Physical therapy tracking",
      "Recovery milestone monitoring",
      "Pain management support",
      "Return to activity guidance"
    ]
  }
];

export const SpecialtiesSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold mb-8">Our Focus Areas</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Specialized support for high-impact surgical recoveries
          </p>
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {specialties.map((specialty, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100"
            >
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                {specialty.icon}
              </div>
              <h3 className="text-2xl font-bold mb-4">{specialty.title}</h3>
              <p className="text-gray-600 mb-6">{specialty.description}</p>
              <ul className="space-y-3">
                {specialty.benefits.map((benefit, i) => (
                  <li key={i} className="flex items-center text-gray-600">
                    <CheckCircle className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" />
                    <span>{benefit}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};